const initialState = {
  datos: [],
  count: {},
  extendedProperties: [],
  loading: true,
  error: null,
  status: null,
  loadingTable: false,
  loadingSave: false,
  statusSave: null,
  dataSave: {},
  loadingFile: false,
  statusFile: null,
  datosFile: {}
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/account_driver/initialState.js